import { PORTAL_BRAND } from '@config/brand'

export default function PortalBrand({ compact = false, className = '' }) {
  return (
    <div className={`portal-brand portal-brand--adjutorem ${compact ? 'compact' : ''} ${className}`.trim()}>
      <span className="portal-brand-mark" aria-hidden="true">
        <img src={PORTAL_BRAND.symbolPath} alt="" />
      </span>
      <span className="portal-brand-copy">
        <strong>{PORTAL_BRAND.stem} <em>{PORTAL_BRAND.accent}</em></strong>
        {!compact ? <small>{PORTAL_BRAND.tagline}</small> : null}
      </span>
    </div>
  )
}
